import React, {useState} from 'react';
import Select from 'react-select';
import { FaIcon } from './Icons.jsx'
import ProjectSelectorModal from './ProjectSelectorComponent/ProjectSelectorModal.jsx';
import Button from '../bootstrap/Button.jsx';

function ProjectSelectorButton({
  name,
  handleOnChangeSelectorInput,
  defaultValues = [],
  rowSelectionMode,
  children,
  type,
  className,
  data
}) {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => setOpenModal(!openModal);

  const handleSaveModal = (data) => {
    handleOnChangeSelectorInput(data);
  }

  const handleChange = (e) => {
    let newData = Array.isArray(e) ? e : [];
    handleOnChangeSelectorInput(newData);
  }

  const handleClick = (e) => {
    handleOpenModal(true);
  }

  return (<>
    <Button className={className} type={type} onClick={handleClick}>
      {children}
    </Button>
    {openModal && <ProjectSelectorModal {...{ handleOpenModal, handleSaveModal }} selectedItems={data} rowSelectionMode={rowSelectionMode}></ProjectSelectorModal>}
  </>);
}

export default ProjectSelectorButton;
